import { Component } from '@angular/core';
import { ApiRequestsService } from './services/api-requests.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'viotal-starter-theme';
}
